<template>
<div>
<slot>
    ** AutomaticScroll Component **
</slot>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import ScrollHelpers from '../helpers/ScrollHelpers'


export default {
    data() {
        return {
            scrollingProgramatically: false,
        
        }
    },

    components: {
        
    },
    
    props: {
        scrollingElementId: String,
        sectionElementClass: String,
        activeSectionKey: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        goToSection(key) {
            let scrollingElement = document.getElementById(this.scrollingElementId)
            let el = scrollingElement.querySelector(`.${this.sectionElementClass}[data-key="${key}"]`)
            this.scrollingProgramatically = true
            scrollingElement.scrollTop = (el ? el.offsetTop - 100 : 0)
            setTimeout( () => {
                this.scrollingProgramatically = false
            }, 1000)
        },
    },

    watch: {
        'activeSectionKey': {
            handler: function(newVal) {
                this.goToSection(newVal)
            }
        }
    },

    mounted() {
        let scrollingElement = document.getElementById(this.scrollingElementId)
       
        ScrollHelpers.scrollStop(scrollingElement, () => {
            if(this.scrollingProgramatically)
                return

            let firstEl = ScrollHelpers.getFirstVisibleElement(scrollingElement, this.sectionElementClass)
            this.$emit('change', firstEl.dataset.key)
        })        
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// AutomaticScroll.vue?29e9ed10